var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-canvas"},[_c('canvas',{staticClass:"s-canvas1",attrs:{"id":"s-canvas","width":_vm.contentWidth,"height":_vm.contentHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }